const text = ({ lightColorPalette }) => lightColorPalette[0];

export default text;
